import { render, staticRenderFns } from "./videoDraft.vue?vue&type=template&id=40d34392&scoped=true"
import script from "./videoDraft.vue?vue&type=script&lang=js"
export * from "./videoDraft.vue?vue&type=script&lang=js"
import style0 from "./videoDraft.vue?vue&type=style&index=0&id=40d34392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d34392",
  null
  
)

export default component.exports